import {
  Button, Card, Modal, Space, Table, Typography,
} from 'antd';
import rentalApi from 'api/rentalApi';
import ToastHelper from 'general/helpers/ToastHelper';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { formatDate, formatMoney, getRentalErrorMessage } from '../../rentalConstants';

const { Text, Title } = Typography;

function RentalExpiredContractsScreen() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [actionLoading, setActionLoading] = useState(false);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const response = await rentalApi.getExpiredContracts();
      setRows(response?.vehicles || []);
    } catch (error) {
      setRows([]);
      ToastHelper.showError(getRentalErrorMessage(error));
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  const refund = (row) => Modal.confirm({
    title: `Hoàn cọc & sang tên xe ${row.vehicleCode}?`,
    content: `Sẽ hoàn ${formatMoney(row.depositAmount)} vào ví đối tác và chuyển xe sang trạng thái đã sang tên. Hành động này không thể hoàn tác.`,
    okText: 'Xác nhận hoàn cọc',
    cancelText: 'Huỷ',
    onOk: async () => {
      setActionLoading(true);
      try {
        await rentalApi.refundDeposit(row.rentalVehicleId);
        ToastHelper.showSuccess('Đã hoàn cọc và sang tên xe');
        load();
      } catch (error) {
        ToastHelper.showError(getRentalErrorMessage(error));
      } finally {
        setActionLoading(false);
      }
    },
  });

  const columns = useMemo(() => [
    { title: 'Mã xe', dataIndex: 'vehicleCode', width: 120, render: (value) => <Text strong>{value}</Text> },
    { title: 'Biển số', dataIndex: 'plate', width: 120 },
    { title: 'Đối tác', key: 'partner', render: (_, row) => row.partner?.contactName || `#${row.rentalPartnerId}` },
    { title: 'Tiền cọc', dataIndex: 'depositAmount', width: 130, render: formatMoney },
    { title: 'Hết hạn hợp đồng', dataIndex: 'contractEndsAt', width: 150, render: formatDate },
    {
      title: '',
      key: 'action',
      width: 180,
      render: (_, row) => (
        <Button type="primary" danger onClick={() => refund(row)} loading={actionLoading}>
          Hoàn cọc & sang tên
        </Button>
      ),
    },
  ], [actionLoading]);

  return (
    <div className="container-fluid px-4 my-4">
      <Card>
        <div className="d-flex flex-wrap justify-content-between align-items-center gap-3 mb-4">
          <div>
            <Title level={4} className="mb-0">Xe hết hạn 36 tháng đồng hành</Title>
            <Text type="secondary">Đã qua mốc 36 tháng, chờ hoàn cọc và sang tên cho đối tác</Text>
          </div>
          <Button onClick={load} loading={loading}>Làm mới</Button>
        </div>
        <Table
          rowKey="rentalVehicleId"
          loading={loading}
          dataSource={rows}
          columns={columns}
          scroll={{ x: 900 }}
          locale={{ emptyText: 'Không có xe nào đến hạn' }}
          pagination={false}
        />
      </Card>
    </div>
  );
}

export default RentalExpiredContractsScreen;
